import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const hasAccessCookie = () => document.cookie.split(";").some((item) => item.trim().startsWith("gashi_staging_access=granted"));

export const StagingAccessGate = ({ children }) => {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [enabled, setEnabled] = useState(false);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [allowed, setAllowed] = useState(hasAccessCookie());

  useEffect(() => {
    if (!window.location.hostname.includes("preview.emergentagent.com") || location.pathname.startsWith("/admin")) {
      setLoading(false);
      return;
    }
    axios.get(`${API}/security-settings/public`).then((res) => {
      setEnabled(!!res.data?.staging_protection_enabled);
      setAllowed(hasAccessCookie() || !res.data?.staging_protection_enabled);
    }).catch(() => setAllowed(true)).finally(() => setLoading(false));
  }, [location.pathname]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await axios.post(`${API}/staging-access`, { password });
      setAllowed(true);
      setPassword("");
    } catch {
      setError("Passwort ungültig");
    }
  };

  if (loading || !window.location.hostname.includes("preview.emergentagent.com") || location.pathname.startsWith("/admin") || !enabled || allowed) {
    return children;
  }

  return (
    <div className="min-h-screen bg-[#0A2A43] text-white flex items-center justify-center px-4" data-testid="staging-access-gate">
      <div className="w-full max-w-md rounded-2xl border border-white/15 bg-white/10 backdrop-blur-xl p-8 shadow-2xl">
        <p className="text-sm uppercase tracking-[0.3em] text-white/60 mb-3">Staging</p>
        <h1 className="text-3xl font-bold font-barlow mb-3">Geschützter Vorschauzugang</h1>
        <p className="text-white/80 text-sm mb-6">Diese Vorschau ist passwortgeschützt und nicht für Suchmaschinen bestimmt.</p>
        <form onSubmit={submit} className="space-y-4">
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full rounded-xl border border-white/20 bg-white/10 px-4 py-3 text-white placeholder:text-white/40" placeholder="Staging-Passwort" data-testid="staging-password-input" />
          {error && <p className="text-sm text-red-300" data-testid="staging-password-error">{error}</p>}
          <button type="submit" className="w-full rounded-xl bg-[#D32F2F] px-4 py-3 font-semibold hover:bg-[#D32F2F]/90" data-testid="staging-password-submit">Vorschau entsperren</button>
        </form>
      </div>
    </div>
  );
};
